export default __webpack_public_path__ + "static/media/MEMO.9a224de8.png";